import { useMemo } from "react";
import { AttributeDefinitionDc, AttributeType } from "@evergis/api";

import { useSegmentStyle } from "../../modules/Style/hooks/useSegmentStyle";
import { useCurrentLayerDefinition } from "./useCurrentLayer";
import { isClusterFillColor } from "../../interfaces/style";
import { ClassificationParameter } from "../../interfaces/classification";

export const useCurrentLayerAttribute = (
  attributeName: string,
  parameter?: ClassificationParameter,
): AttributeDefinitionDc => {
  const style = useSegmentStyle();
  const layerDefinition = useCurrentLayerDefinition();

  return useMemo(() => {
    return parameter && isClusterFillColor(style.symbol, parameter)
      ? ({ type: AttributeType.Int32 } as AttributeDefinitionDc)
      : layerDefinition && attributeName
      ? layerDefinition.attributes[attributeName]
      : ({} as AttributeDefinitionDc);
  }, [style.symbol, parameter, layerDefinition, attributeName]);
};
